/// <reference types="vite/client" />
import settingsEn from "@ja/settings/locales/en.json";
import settingsFr from "@ja/settings/locales/fr.json";

import crudEn from "@ja/crud/locales/en.json";
import crudFr from "@ja/crud/locales/fr.json";

import { createPortalI18n } from "../../js/i18n.ts";

import en from "./locales/en.json";
import fr from "./locales/fr.json";

/**
 * Discover model translations from the app's resources directory.
 * These are loaded at build time from glob patterns.
 */
const modelModules = import.meta.glob<{
  default: { en?: object; fr?: object };
}>(
  [
    // Standard Laravel structure
    "/resources/lang/models/*.ts",
    // Alt: backend subfolder
    "/backend/resources/lang/models/*.ts"
  ],
  { eager: true }
);

// Build model messages structure
const modelMessages: {
  en: { models: Record<string, object> };
  fr: { models: Record<string, object> };
} = {
  en: { models: {} },
  fr: { models: {} }
};

for (const path in modelModules) {
  // Extract model name from path (e.g., "/resources/lang/models/client.ts" -> "client")
  const modelName = path.split("/").pop()?.replace(".ts", "");
  if (modelName) {
    const config = modelModules[path].default;
    if (config.en) {
      modelMessages.en.models[modelName] = config.en;
    }
    if (config.fr) {
      modelMessages.fr.models[modelName] = config.fr;
    }
  }
}

/**
 * Vue-i18n instance for PortalAuth
 * Uses the shared portal i18n utility
 * Includes CrudManager translations for CRUD components
 * Includes model translations discovered from app's resources
 */
const i18n = createPortalI18n({
  messages: {
    en: { ...crudEn, ...settingsEn, ...en, ...modelMessages.en },
    fr: { ...crudFr, ...settingsFr, ...fr, ...modelMessages.fr }
  }
});

export default i18n;
